import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton, useTheme } from "@mui/material";
import InputBase from "@mui/material/InputBase";
import { useContext } from "react";
import { ColorModeContext, tokens } from "../theme";
import { Box } from "@mui/material";
import { searchPatientsOnName } from '../services/patientService';

function SearchBar({ placeholder, data,onPatientSelect }) {
  const [filteredData, setFilteredData] = useState([]);
  const [wordEntered, setWordEntered] = useState("");


  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);

  const handleFilter = (event) => {
    const searchWord = event.target.value;
    setWordEntered(searchWord);
    const newFilter = data.filter((value) => {
      return value.name.toLowerCase().includes(searchWord.toLowerCase());
    });

    if (searchWord === "") {
      setFilteredData([]);
    } else {
      setFilteredData(newFilter);
    }
  };

  const clearInput = () => {
    setFilteredData([]);
    setWordEntered("");
  };

  const handleSelect = (patient) => {
    onPatientSelect(patient);
    setQuery('');
    setResults([]);
  };


  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);

  const handleSearch = async (name) => {
    setQuery(name);
    if (name.length > 2) {
      const patients = await searchPatientsOnName(name);
      setResults(patients);
    } else {
      setResults([]);
    }
  };

  return (
      
    <div className="search1">

     <Box
        display="flex"
        backgroundColor={colors.primary[400]}
        borderRadius="3px"
        marginBottom="25px"
        maxWidth="400px"
        maxHeight="150px"
      >
        <InputBase sx={{ ml: 1, flex: 1 }} placeholder="Search existing patients and assign a doctor" 
        type="text"
        value={wordEntered}
        onChange={handleFilter} />
        
        <div className="searchIcon1">
          {filteredData.length === 0 ? (
            <IconButton type="button" sx={{ p: 1 }}>
            <SearchIcon />
            </IconButton>
          ) : (
            <CloseIcon id="clearBtn" onClick={clearInput} />
          )}
        </div>
      </Box>
      {filteredData.length != 0 && (
        <div className="dataResult1" >
          {filteredData.slice(0, 15).map((value) => {
            return (
              <a href="#"  onClick={() => handleSelect(value)} className="dataItem1">
                <p>{value.name} </p>
              </a>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default SearchBar;